<template>
    <div>
        <h2>カードデータ編集</h2>
        <v-container fluid>
            <v-row align="center">
                <v-col cols="12" sm="6" lg="3" class="justify-start">
                    <v-card>
                        <v-img :src="url_prefix + card.image"></v-img>
                        <div class="pa-3">
                            <div>{{ card.card_name }}</div>
                            <div>{{ card.color }}</div>
                            <div>{{ card.lot }}</div>
                        </div>
                    </v-card>
                </v-col>

                <v-col class="d-flex" cols="12" sm="8"></v-col>
                
                <v-col class="d-flex" cols="12" sm="4">
                    <v-text-field v-model="card_name" label="カード名" clearable></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="card_color" :items="color" label="色" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-select v-model="card_lot" :items="lot" label="収録弾" clearable></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-checkbox v-model="is_psa" label="PSAカードとして登録する"></v-checkbox>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                    <v-btn block color="primary" elevation="2" @click="postData">変更する</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>


<script>
export default {
    data: () => ({
        card: '',
        card_name: '',
        card_color: '',
        card_lot: '',
        is_psa: null,
        color: ['赤', '緑', '青', '紫', '黄', '黒'],
        lot: [
                'ブースターパック 新時代の主役 [OP-05]',
                'ブースターパック 謀略の王国 [OP-04]',
                'スタートデッキ ゾロ&サンジ [ST-12]',
                'スタートデッキ Side ウタ [ST-11]',
                'アルティメットデッキ"三船長"集結 [ST-10]',
                '限定商品収録カード',
                'プレミアムブースター ONE PIECE CARD THE BEST【PRB-01】',
                'エクストラブースター メモリアルコレクション【EB-01】',
                'ブースターパック 二つの伝説【OP-08】',
                'ブースターパック 500年後の未来【OP-07】',
                'ブースターパック 双璧の覇者【OP-06】',
                'ブースターパック 強大な敵【OP-03】',
                'ブースターパック 頂上決戦【OP-02】',
                'ブースターパック ROMANCE DAWN【OP-01】',
                'スタートデッキ 黄 シャーロット・カタクリ【ST-20】',
                'スタートデッキ 黒 スモーカー【ST-19】',
                'スタートデッキ 紫 モンキー・D・ルフィ【ST-18】',
                'スタートデッキ 青 ドンキホーテ・ドフラミンゴ【ST-17】',
                'スタートデッキ 緑 ウタ【ST-16】',
                'スタートデッキ 赤 エドワード・ニューゲート【ST-15】',
                'スタートデッキ 3D2Y【ST-14】',
                'アルティメットデッキ 3兄弟の絆【ST-13】',
                'スタートデッキ Side ヤマト【ST-09】',
                'スタートデッキ Side モンキー・D・ルフィ【ST-08】',
                'スタートデッキ ビッグ・マム海賊団【ST-07】',
                'スタートデッキ 海軍【ST-06】',
                'スタートデッキ ONE PIECE FILM edition【ST-05】',
                'スタートデッキ 百獣海賊団【ST-04】',
                'スタートデッキ 王下七武海【ST-03】',
                'スタートデッキ 最悪の世代【ST-02】',
                'スタートデッキ 麦わらの一味【ST-01】',
                'ファミリーデッキセット',
                'プロモーションカード',
        ],
        url_prefix: "",
    }),
    methods: {
        postData() {
            if(this.card_name != this.card.card_name || this.card_color != this.card.color || this.card_lot != this.card.lot || this.is_psa != this.card.is_psa) {
                this.axios
                .patch(`${process.env.VUE_APP_API_ORIGIN}/card/update`, {
                    card_name: this.card_name,
                    color: this.card_color,
                    lot: this.card_lot,
                    is_psa: this.is_psa,
                    edited_account: this.$store.getters.getStoreId,
                    card_id: this.card.id,
                })
                .then(res => {
                    this.$router.push({ name: 'ViewCards'})
                })
                .catch(() => {
                    alert(e)
                })
            }
        },
    },
    mounted: function () {
        this.url_prefix = `${process.env.VUE_APP_API_ORIGIN}`
        var params = {}
        params.card_id = this.$route.params.card_id
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/card/search`, {
            params
        })
        .then(res => {
            this.card = res.data[0]
            this.card_name = this.card.card_name
            this.card_color = this.card.color
            this.card_lot = this.card.lot
            this.is_psa = this.card.is_psa
        })
        .catch(e => {
            console.log(e.response.data)
        })
    }
}
</script>
